var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoolUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7555 28.9813C24.9999 28.8181 25.3383 28.9228 25.4386 29.1927L29.239 39.4161C29.3612 39.7449 29.0532 40.0719 28.7022 39.9861L14.71 36.5673C14.3337 36.4753 14.2445 35.9989 14.5637 35.7858L24.7555 28.9813Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.21 26.7247C27.1924 26.6775 27.1835 26.6277 27.1835 26.5776V16.2741C27.1835 15.9827 26.8928 15.7732 26.603 15.8558L14.6133 19.273C14.3235 19.3556 14.0329 19.1461 14.0329 18.8547V12.1958C14.0329 12.0597 14.0988 11.9314 14.211 11.8489L29.8352 0.365944C30.0524 0.206351 30.3655 0.267289 30.5015 0.495606L39.9399 16.3415C40.0068 16.4538 40.0185 16.5889 39.9718 16.7103L32.0254 37.4043C31.8788 37.7861 31.3179 37.7832 31.1756 37.3999L27.21 26.7247Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0322 1.25901C10.1077 1.18775 10.2066 1.1442 10.3119 1.13592L24.7325 0.00162366C25.1829 -0.0338079 25.4028 0.519633 25.0431 0.783536L12.7517 9.8014C12.6379 9.88487 12.4899 9.91155 12.3526 9.87337L4.25862 7.62322C3.9257 7.53066 3.8199 7.12624 4.06746 6.89244L10.0322 1.25901Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00559 9.88743C2.04007 9.62137 2.31292 9.44802 2.57998 9.52249L11.158 11.9145C11.3515 11.9684 11.4847 12.1392 11.4847 12.3335V22.0181C11.4847 22.3096 11.7756 22.5191 12.0654 22.4363L23.9719 19.0343C24.2618 18.9515 24.5527 19.161 24.5527 19.4525V25.604C24.5527 25.7468 24.4801 25.8806 24.3585 25.9622L11.0039 34.9145C10.8297 35.0313 10.5948 35.0156 10.4389 34.8769L0.145484 25.7115C0.0382714 25.6161 -0.0146003 25.4766 0.00349609 25.337L2.00559 9.88743Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolUrl);
export default __webpack_public_path__ + "static/media/pool_url.409e3768213b65e80fe222ec75f71bf5.svg";
export { ForwardRef as ReactComponent };